
import { defineComponent } from "vue";

import useLuosikeState from "./hooks/useLuosikeState";

export default defineComponent({
  setup() {
    const { luosikeList } = useLuosikeState();

    return {
      luosikeList,
    };
  },
});
